export const SHOPIFY_ORDER_NUMBER = 'getOrderByNumber';
export const SHOPIFY_EMAIL = 'getOrderByEmail';
export const SHOPIFY_PHONE_NUMBER = 'getOrderByPhoneNumber';
export const SHOPIFY_FULL_NAME = 'getOrderByShopifyFullName';
export const AMAZON_ORDER_NUMBER = 'getOrderByAmazonOrderNumber';
export const AMAZON_EMAIL = 'getOrderByAmazonEmail';
export const ZENDESK_FULL_NAME = 'getOrderByZendeskFullName';
export const ZENDESK_EBAY_USERNAME = 'getOrderByEbayUsername';
export const ZENDESK_ORDER_NUMBER = 'getOrderByZendeskOrderNumber';
export const ZENDESK_EMAIL = 'getOrderByZendeskEmail';
export const CUSTOM_SELLER_EMAIL = 'getOrderByCustomSellerEmail';
export const SIMPLR_ORDER_ID = 'getOrderByOrderId';
export const SIMPLR_ORDER_EMAIL = 'getSimplrOrderByEmail';
export const SIMPLR_ORDER_PHONE_NUMBER = 'getSimplrOrderByPhoneNumber';
export const SIMPLR_ORDER_CUSTOMER_NAME = 'getSimplrOrderByCustomerName';
export const SIMPLR_ORDER_CUSTOMER_ID = 'getSimplrOrderByCustomerId';
export const SIMPLR_ORDER_SUBSCRIPTION_EMAIL = 'SIMPLR_ORDER_SUBSCRIPTION_EMAIL';
export const COMMON_SUBSCRIPTION_EMAIL = 'COMMON_SUBSCRIPTION_EMAIL';
export const RBI_EMAIL = 'getRbiOrdersByEmail';
export const RBI_ID = 'getRbiOrderById';
export const RBI_CARD_ID = 'getRbiOrdersByCardId';
export const SALESFORCE_ORDER_EMAIL = 'getSalesforceOrderByOrderEmail';
export const SALESFORCE_ORDER_ID = 'getSalesforceOrderByOrderId';
export const BIG_COMMERCE_ORDER_EMAIL = 'getBigCommerceOrderByOrderEmail';
export const BIG_COMMERCE_ORDER_ID = 'getBigCommerceOrderByOrderId';
export const REVOLVE_ORDER_EMAIL = 'getRevolveOrderByOrderEmail';
export const REVOLVE_ORDER_ID = 'getRevolveOrderByOrderId';
export const COMMON_ORDER_EMAIL = 'getCommonOrderByEmail';
export const COMMON_ORDER_NUMBER = 'getCommonOrderByOrderNumber';
export const COMMON_ORDER_PHONE_NUMBER = 'getCommonOrderByPhoneNumber';

// There can be multiple ways to perform a dynamic search - we do not know the names in advance
export const COMMON_ORDER_DYNAMIC_INPUT = 'getCommonOrderDynamicInput';
export const COMMON_ORDER_DYNAMIC_INPUT_0 = `${COMMON_ORDER_DYNAMIC_INPUT}0`;
export const COMMON_ORDER_DYNAMIC_INPUT_1 = `${COMMON_ORDER_DYNAMIC_INPUT}1`;
export const COMMON_ORDER_DYNAMIC_INPUT_2 = `${COMMON_ORDER_DYNAMIC_INPUT}2`;

export const EMAIL_SEARCH_TYPES = [
  SHOPIFY_EMAIL,
  AMAZON_EMAIL,
  ZENDESK_EMAIL,
  CUSTOM_SELLER_EMAIL,
  SIMPLR_ORDER_EMAIL,
  RBI_EMAIL,
  SALESFORCE_ORDER_EMAIL,
  BIG_COMMERCE_ORDER_EMAIL,
  REVOLVE_ORDER_EMAIL,
  COMMON_ORDER_EMAIL,
];
